"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const __1 = require("..");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ScreenLoader = () => (core_1.jsx("div", { className: styles_scss_1.default.screenLoader },
    core_1.jsx(__1.CircularLoader, null)));
exports.default = ScreenLoader;
